import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbProp from './breadcrumbProp';
import Anchor from '../Anchor';

export default function Breadcrumbs({ breadcrumbs }) {
  return (
    breadcrumbs.length > 1 && (
      <ul className="m-subheader__breadcrumbs m-nav m-nav--inline">
        <li className="m-nav__item m-nav__item--home">
          <Anchor href="/" className="m-nav__link m-nav__link--icon">
            <i className="m-nav__link-icon la la-home" />
          </Anchor>
        </li>
        {breadcrumbs.map(({ link, text }) => (
          <React.Fragment key={link}>
            <li className="m-nav__separator">-</li>
            <li className="m-nav__item">
              <Anchor href={link} className="m-nav__link">
                <span className="m-nav__link-text">{text}</span>
              </Anchor>
            </li>
          </React.Fragment>
        ))}
      </ul>
    )
  );
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(BreadcrumbProp.propType))
    .isRequired,
};
